// Shared tokens for the pill ⇄ More card morph (BottomTabBar + MoreMenuSheet).
export const DOCK_SURFACE_ID = 'dock-surface'
export const PILL_RADIUS = 31 // 62px pill / 2
export const CARD_RADIUS = 26
// Width, height and corner radius all ride this spring.
export const MORPH_SPRING = { type: 'spring', stiffness: 380, damping: 34, mass: 0.9 } as const
/** Height of the dock pill row (BottomTabBar); the "+" slot beside it matches. */
export const DOCK_PILL_H = 62
